module.exports = __webpack_public_path__ + "static/media/104.67eb299b.jpg";